/* Ancient Bliss — Build-a-Bundle engine.
   Pick products (+ quantity), live tiered discount, running total, add all to cart.
   Shopify applies the 15/20% tiers automatically. The existing 25% code is
   applied through Shopify's discount redirect when the five-item tier is reached. */
class ABBundle extends HTMLElement {
  connectedCallback() {
    this.tiers = JSON.parse(this.dataset.tiers || '[]').sort((a, b) => b.min - a.min);
    this.symbol = this.dataset.symbol || '$';
    this.discountCode = this.dataset.discountCode || '';
    this.discountMin = parseInt(this.dataset.discountMin, 10) || 5;
    this.sel = new Map(); // variantId -> { price, qty, title }
    this.adding = false;
    this.querySelectorAll('[data-variant-id]').forEach((card) => {
      const id = card.dataset.variantId;
      card.querySelector('[data-add]')?.addEventListener('click', () => this.setQty(id, this.qty(id) + 1, card));
      card.querySelector('[data-inc]')?.addEventListener('click', () => this.setQty(id, this.qty(id) + 1, card));
      card.querySelector('[data-dec]')?.addEventListener('click', () => this.setQty(id, this.qty(id) - 1, card));
    });
    this.cta = this.querySelector('[data-bundle-add]');
    this.cta?.addEventListener('click', () => this.addToCart());
    this.render();
  }
  qty(id) { return this.sel.get(id)?.qty || 0; }
  setQty(id, qty, card) {
    if (this.adding) return;
    const error = this.querySelector('[data-cart-err]');
    if (error) error.hidden = true;
    if (qty <= 0) this.sel.delete(id);
    else this.sel.set(id, { price: parseInt(card.dataset.price, 10) || 0, qty, title: card.dataset.title || '' });
    const q = this.qty(id);
    const add = card.querySelector('[data-add]');
    const step = card.querySelector('[data-stepper]');
    if (add) add.style.display = q > 0 ? 'none' : '';
    if (step) { step.style.display = q > 0 ? 'flex' : 'none'; const s = step.querySelector('[data-qty]'); if (s) s.textContent = q; }
    card.classList.toggle('is-picked', q > 0);
    this.render();
  }
  tierFor(c) { return this.tiers.find((t) => c >= t.min) || null; }
  nextTier(c) { return [...this.tiers].sort((a, b) => a.min - b.min).find((t) => c < t.min) || null; }
  money(c) { return this.symbol + (c / 100).toFixed(2); }
  render() {
    let count = 0, subtotal = 0;
    this.sel.forEach((v) => { count += v.qty; subtotal += v.price * v.qty; });
    const tier = this.tierFor(count), pct = tier ? tier.pct : 0;
    const savings = Math.floor((subtotal * pct) / 100), total = subtotal - savings;
    const maxMin = this.tiers.length ? Math.max(...this.tiers.map((t) => t.min)) : 5;
    const progress = Math.min(100, (count / maxMin) * 100);
    this.querySelectorAll('[data-fill]').forEach((f) => (f.style.width = progress + '%'));
    this.setText('[data-count]', count + (count === 1 ? ' item' : ' items'));
    this.setText('[data-subtotal]', this.money(subtotal));
    this.setText('[data-savings]', savings ? '−' + this.money(savings) : this.money(0));
    this.setText('[data-discount-label]', pct ? 'Discount (' + pct + '%)' : 'Discount');
    this.setText('[data-total]', this.money(total));
    const next = this.nextTier(count);
    this.setText('[data-tier-msg]', next ? 'Add ' + (next.min - count) + ' more to save ' + next.pct + '%' : (tier ? "You're saving " + pct + '% — max unlocked!' : 'Add 3 to start saving'));
    this.querySelectorAll('[data-tier-min]').forEach((el) => {
      const active = count >= parseInt(el.dataset.tierMin, 10);
      el.style.opacity = active ? '1' : '0.6';
    });
    if (this.cta) {
      this.cta.disabled = count === 0;
      this.cta.textContent = count === 0 ? 'Add products to begin' : 'Add ' + count + ' to cart · ' + this.money(total);
    }
  }
  setText(sel, val) { const el = this.querySelector(sel); if (el) el.textContent = val; }
  async addToCart() {
    const items = [...this.sel.entries()].map(([id, v]) => ({ id: Number(id), quantity: v.qty }));
    if (!items.length || this.adding) return;
    this.adding = true;
    const error = this.querySelector('[data-cart-err]');
    if (error) error.hidden = true;
    this.cta.disabled = true; this.cta.textContent = 'Adding…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) {
        const data = await r.json().catch(() => null);
        throw new Error(data?.description || data?.message || 'Could not add your bundle. Please try again.');
      }
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      window.location.href = this.discountCode && count >= this.discountMin
        ? root + 'discount/' + encodeURIComponent(this.discountCode) + '?redirect=' + encodeURIComponent(root + 'cart')
        : root + 'cart';
    } catch (e) {
      this.adding = false;
      this.render();
      if (error) { error.textContent = e.message || 'Could not add your bundle. Please try again.'; error.hidden = false; }
    }
  }
}
customElements.define('ab-bundle', ABBundle);
